import moment from "moment";
import React from "react";
import { Table } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { Link } from "react-router";
import { ACCEPTED_STATUS } from "../../lib/utils";

export default function MomoCard({ item, illustration }) {

  const { id, date, fromName, from, status, type, amount, fee, currency, loans, rowState } = item;

  const renderLoans = () => {

    if(!loans || !loans.length) return null;
    return loans.map((item, index) => {

      const { currency, amount, clientName, clientPhoneNumber,
        clientId, createdOn, isBusiness, name } = item;
      const clientDetailLink = `${ isBusiness ?  '/businesses' : '/customers'}/${ clientId }/detail`;
  
      return <Table responsive striped condensed hover key={ index }>
        <tbody>
  
          <tr>
            <td colSpan={2}>
              { index + 1 }{')'} { name } { amount } { currency }
            </td>
          </tr>
  
          <tr>
            <td>{ isBusiness ? 'Business' : 'Customer' }</td>
            <td>
              <Link to={ clientDetailLink } target='_blank'>{ clientName }</Link>&nbsp; &nbsp;
              <small className="gray"><FontAwesome name='phone'/> { clientPhoneNumber }</small>
            </td>
          </tr>
  
          <tr>
            <td>Created on</td>
            <td>{ createdOn }</td>
          </tr>
  
          <tr>
            <td colSpan={2} className="align-right">
              <Link to={`/loans/${item.id}/detail`} target='_blank'>
                See more <FontAwesome name="mail-forward" title='Show details' />
              </Link>
            </td>
          </tr>
  
        </tbody>
      </Table>
    })
  } 

  return (
    <Table responsive striped bordered condensed hover>
      <tbody>

        <tr>
          <td width="30%">ID</td>
          <td>{ id }</td>
        </tr>

        <tr>
          <td>
            <span>From</span><br/>
            <span className="gray">Date</span>
          </td>
          <td>
            <span>{ fromName } ({ from })</span><br/>
            <span className="gray">{ moment(date).format('lll') }</span>
          </td>
        </tr>

        <tr>
          <td>
            <span>Type</span><br/>
            <span className="gray">Status</span>
          </td>
          <td>
            <span>{ type }</span><br/>
            <span className="gray">{ status }</span>
          </td>
        </tr>

        <tr>
          <td>
            <span>Amount</span><br/>
            <span className="gray">Fee</span>
          </td>
          <td>
            <span>{ amount }</span><br/>
            <span className="gray">{ fee }</span>
          </td>
        </tr>
  
        <tr>
          <td>Currency</td>
          <td>{ currency }</td>
        </tr>

        <tr>
          <td>Loans found ({ loans ? loans.length : 0 })</td>
          <td>{ renderLoans() }</td>
        </tr>

        <tr>
          <td>Tenure</td>
          <td className={ rowState === ACCEPTED_STATUS.key ? 'green' : 'red' }>
            { illustration.icon } { illustration.title }
          </td>
        </tr>

      </tbody>
    </Table>
  )
}


// WEBPACK FOOTER //
// ./src/components/Loans/MomoCard.js